import { methods, request } from "./base";

const offersApis = {
  coupanlist: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/patient_plans/discount_list",
      payload: data,
    }),
  checkDiscount: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/patient_plans/check_discount",
      payload: data,
    }),
};

export default offersApis;
